import React from 'react';

interface TrustyBytesLogoProps {
  className?: string;
  size?: number | string;
  blueColor?: string;
  greenColor?: string;
}

export function TrustyBytesLogo({
  className = 'size-7',
  size,
  blueColor = '#0062D2',
  greenColor = '#8CC63F',
}: TrustyBytesLogoProps) {
  const style = size ? { width: size, height: size } : undefined;

  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-label="TrustyBytes Logo"
    >
      {/* Blue 'C' / Left bracket frame */}
      <path
        d="M11 3.5H69.5L62 18.5H25.5V66.5H71V81H11V3.5Z"
        fill={blueColor}
      />
      {/* Green '1' stem */}
      <path
        d="M67 18.5L74.5 3.5H89V81H74.5V18.5H67Z"
        fill={greenColor}
      />
      {/* Green speech-bubble bottom tail */}
      <path
        d="M71.5 84.5H89L89 96.5L71.5 84.5Z"
        fill={greenColor}
      />
    </svg>
  );
}

export const TRUSTYBYTES_LOGO_SVG_RAW = (blueColor = '#0062D2', greenColor = '#8CC63F') =>
  `<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:28px;height:28px;display:inline-block;vertical-align:middle;">` +
  `<path d="M11 3.5H69.5L62 18.5H25.5V66.5H71V81H11V3.5Z" fill="${blueColor}"/>` +
  `<path d="M67 18.5L74.5 3.5H89V81H74.5V18.5H67Z" fill="${greenColor}"/>` +
  `<path d="M71.5 84.5H89L89 96.5L71.5 84.5Z" fill="${greenColor}"/>` +
  `</svg>`;